<template>
    <div class="dropdown-content " id="myDropdown">
        <button v-for="(modal, i) in details.modals" :key="i+1" @click="openModal(modal.link)" class="p-3">
            {{modal.name}}
        </button>
        <router-link v-for="(link, i) in details.info" :key="i" :to="{ name: link.link, query: { ...details.queryStrings } }">
            {{ link.name }}
        </router-link>
        <button class="" @click="deleteNow" v-if="details.delete.hasDelete">
            {{details.delete.name}}
        </button>
    </div>
</template>

<script>
export default {
    props: ['details'],
    created() {
    }, 
    methods: {
        openModal(link) {
            this.$eventHub.$emit(link, this.details.itemData)
        },
        deleteNow() {
            this.$eventHub.$emit(this.details.delete.deleteName, this.details.queryStrings[this.details.delete.query])
        }
    },
}
</script>

<style>

</style>